import React, {Fragment, useReducer, useEffect, useCallback} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import isEqual from 'lodash.isequal';

import ai from "../../../helpers/axios";
import useRedirectIfVerified from "../../../helpers/use-redirect-if-verified";
import { isTripClosedForUser } from "../../../helpers/is-trip-editable";

import { toast } from "react-toastify";
import { useHistory, useLocation, useParams, Link } from "react-router-dom";

// import Select from "react-select";
import TextInput from "../../text-input";
// import PhoneInput from "react-phone-number-input";

import "react-json-pretty/themes/monikai.css";
import JSONPretty from "react-json-pretty";

import "react-phone-number-input/style.css";

import * as Sentry from "@sentry/react";
import Loader from "../../../components/loader";

import OperatorAutocomplete from "../../opi/operator-autocomplete";
import AircraftAutocomplete from "../../aircrafts/aircraft-autocomplete";

import Select from "react-select";

// mui imports
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import NumberFormat from "react-number-format";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import OperatorCancellationPolicies from "./operator-cancellation-policies";
import ReactModal from "react-modal";

import { TRIP_EDIT_REASON_OPTIONS } from "../trip-disruptions-reasons";

import { LoadingButton } from "../../shared/loading-button";

import currencyFormatter from "../../../helpers/currencyFormatter";
import { formatTripDate } from "../../../helpers/dates";
import generateYearRangeOptions from "../../../helpers/generate-year-range-options";
import { findServiceFee } from "../../../helpers/serviceFee";
import PageHeader from "../../shared/page-header";
import UnsavedChangesWarningModal from "../../unsaved-changes-warning-modal/unsaved-changes-warning-modal";
import getApiErrorMessage from "../../../helpers/get-api-error-message";

let toastOptions = {
  position: "top-right",
  autoClose: 6000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  icon: false,
};

const initialValues = {
  selectedOperator: null,
  selectedAircraft: null,
  whichLeg: "",
  aircraftSeats: "",
  tailNumber: "",
  selectedYOM: null,
  selectedYOMEnd: null,
  yomIsRange: false,
  selectedInteriorRefurbYear: null,
  selectedInteriorRefurbYearEnd: null,
  interiorRefurbYearIsRange: false,
  crew: "",
  notes: "",
  operatorCancellationPolicies: [
    {
      type: 1,
      value: "",
      dueDate: "",
    },
  ],
  dusCancellationPolicy: {
    type: 1,
    value: "",
  },
  ownerApproval: "no",
  taxableOperatorPrice: null,
  nonTaxableOperatorPrice: null,
  operatorPrice: null,
  grossCommission: null,
  selectedFET: null,
  FET: 0,
  selectedSegmentFees: null,
  segmentFees: '',
  referralFees: null,
  discount: null,
  paymentType: null,
  amenities: [],
  safetyStandards: [],
};

let initialState = {
  lead: null,
  isRedirecting: false,
  ofrTag: "",
  operatorOptions: [],
  aircraftOptions: [],
  netCommission: null,
  commissionPercentage: null,
  showCustomFETField: false,
  showCustomSegmentFeesField: false,
  segmentFees: 31.5,
  totalClientPayment: null,
  serviceFee: 0,
  serviceFeeBrackets: null,
  isServiceFeeFrozen: false,
  ccFee: 0,
  loading: true,
  title: "New OFR",
  isNew: true,
  selectedLegs: [
    { index: 1, selected: false },
    { index: 2, selected: false },
  ],
  itineraryLegs: [],
  isFormLoading: false,
  isSubmitAndAddAnotherLoading: false,
  isSubmitAndViewTripLoading: false,
  tripTag: "",
  tripVerified: false,
  tripLocked: false,
  isReadOnly: false,
  showEditModal: false,
  editModalReason: null,

  ...initialValues,

  initialFormValues: initialValues,
  operatorCancellationPoliciesChanged: false,
  unsavedChanges: {},
};

const parseValue = (value, fieldType) => {
  let finalValue = value;

  if (fieldType === "number") {
    finalValue = parseInt(value);
    if (isNaN(finalValue)) {
      finalValue = null;
    }
  }

  if (fieldType === "float") {
    finalValue = parseFloat(value);
    if (isNaN(finalValue)) {
      finalValue = null;
    }
  }

  return finalValue;
};

const reducer = (state, action) => {
  switch (action.type) {
    case "fieldChanged": {
      return {
        ...state,
        [action.field]: parseValue(action.value, action?.fieldType),
        ...(["operatorCancellationPolicies", "dusCancellationPolicy"].includes(action.field) && {
          operatorCancellationPoliciesChanged: true,
        })
      };
    }

    case "resetState": {
      return {
        ...initialState,
      };
    }

    case "dataDownloaded": {
      let data = action?.payload?.data;
      if (!data) {
        return state;
      }

      let selectedYOM,
        selectedSegmentFees,
        selectedInteriorRefurbYear,
        selectedFET,
        selectedYOMEnd,
        selectedInteriorRefurbYearEnd = null;

      if (data.yom) {
        selectedYOM = {
          label: data.yom,
          value: data.yom,
        };
      }

      if (data.interiorRefurbYear) {
        selectedInteriorRefurbYear = {
          label: data.interiorRefurbYear,
          value: data.interiorRefurbYear,
        };
      }

      if (data?.segmentFees?.value && data?.segmentFees?.label) {
        selectedSegmentFees = {
          value: data?.segmentFees?.value,
          label: data?.segmentFees?.label,
        };
      }

      if (data?.fet?.value && data?.fet?.label) {
        selectedFET = {
          value: data?.fet?.value,
          label: data?.fet?.label,
        };
      }

      if (data?.interiorRefurbYearIsRange && data.interiorRefurbYearEnd) {
        selectedInteriorRefurbYearEnd = {
          label: data.interiorRefurbYearEnd,
          value: data.interiorRefurbYearEnd,
        };
      }

      if (data?.yomIsRange && data.yomIsRange) {
        selectedYOMEnd = {
          label: data.yomEnd,
          value: data.yomEnd,
        };
      }

      let ownerApproval = data?.ownerApproval === true ? "yes" : "no";

      let firstTwoCities = "";
      let showIndicator = false;
      let allCities = "";

      if (data?.operatorData?.cities?.length) {
        firstTwoCities = data?.operatorData?.cities.slice(0, 2);
        firstTwoCities = firstTwoCities.join(", ");

        if (data?.operatorData?.cities.length > 2) {
          showIndicator = true;
        }

        allCities = data?.operatorData?.cities.join(", ");
      }

      let labelString = `<span ${showIndicator ? `title="${allCities}"` : ""}>${
        data?.operator?.name
      } ${firstTwoCities ? `| ${firstTwoCities} |` : "| "} OPI ${
        data?.operatorData?.composedScore || "Unrated"
      }${
        showIndicator
          ? '<span class="material-icons select-label-indicator">info</span>'
          : ""
      }</span>`;

      let selectedOperator = {
        value: data?.operator?.name || "",
        label: data?.operator?.name || "",
        _id: data?.operator?.id,
        operatorName: data?.operator?.name,
        composedScore: data?.operatorData?.composedScore,
        specs: {
          showIndicator,
          firstTwoCities,
          allCities,
          composedScore: data?.operatorData?.composedScore,
        },
      };

      const initialValues = {
        selectedAircraft: {
          value: data?.aircraft?.id,
          label: data?.aircraft?.name,
          aircraftType: {
            _id: data?.aircraft?.aircraftType?.id,
            name: data?.aircraft?.aircraftType?.name,
          },
          seats: data?.aircraft?.seats || null,
        },
        aircraftSeats: data?.aircraft?.seats || "",
        selectedOperator,
        selectedFET,
        FET: data?.fet?.amount,
        selectedSegmentFees,
        segmentFees: data?.segmentFees?.amount,
        referralFees: data?.referralFees,
        discount: data?.discount,
        paymentType: data?.paymentType,
        amenities: data?.amenities || [],
        safetyStandards: data?.safetyStandards || [],
        grossCommission: data.grossCommission,
        taxableOperatorPrice: data.taxableOperatorPrice,
        nonTaxableOperatorPrice: data.nonTaxableOperatorPrice,
        operatorPrice: data.operatorPrice,
        notes: data.notes,
        tailNumber: data.tailNumber,
        selectedYOM,
        yomIsRange: data.yomIsRange,
        ownerApproval,
        crew: data.crew || "",
        selectedInteriorRefurbYear,
        interiorRefurbYearIsRange: !!data.interiorRefurbYearIsRange,
        selectedYOMEnd,
        selectedInteriorRefurbYearEnd,
        whichLeg: data?.whichLeg?.toString() || "",
        operatorCancellationPolicies:
          data?.operatorCancellationPolicies?.length >= 1
            ? data?.operatorCancellationPolicies
            : [
              {
                type: 1,
                value: "",
                dueDate: "",
              },
            ],
        dusCancellationPolicy: data?.dusCancellationPolicy || {
          type: 1,
          value: 0,
        },
      };

      if (initialValues.operatorPrice && (!initialValues.taxableOperatorPrice && !initialValues.nonTaxableOperatorPrice)) {
        initialValues.taxableOperatorPrice = initialValues.operatorPrice;
        initialValues.nonTaxableOperatorPrice = 0;
      }

      return {
        ...state,
        ofrTag: data?.ofrTag,
        title: "Edit Operator Financial Record",
        loading: false,
        totalCostOfGoods: data.totalCostOfGoods,
        totalTaxesAndFees: data.totalTaxesAndFees,
        totalClientPayment: data.totalClientPayment,
        netCommission: data.netCommission,
        commissionPercentage: data.commissionPercentage,
        serviceFee: data.serviceFee ?? 0,
        isServiceFeeFrozen: data.stage === "signed",
        sourcingRecord: data,

        ...initialValues,

        initialFormValues: initialValues,
      };
    }

    case "loadingChanged": {

      if (action.value === false) {
        return {
          ...state,
          isFormLoading: false,
          isSubmitAndAddAnotherLoading: false,
          isSubmitAndViewTripLoading: false,
        }
      }

      return {
        ...state,
        isFormLoading: true,
        [action.field]: action.value,
      }
    }

    case "unsavedChanges": {
      const updatedUnsavedChanges = {...state.unsavedChanges};

      if (!action.value) {
        delete updatedUnsavedChanges[action.field];
      } else {
        updatedUnsavedChanges[action.field] = true;
      }

      return {
        ...state,
        unsavedChanges: updatedUnsavedChanges
      };
    }

    default:
      break;
  }
  return state;
};

const OFRBuilderContent = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const history = useHistory();
  const location = useLocation();
  const { editReason, viewMode } = location.state || {};

  useEffect(() => {
    if (viewMode) {
      dispatch({ type: "fieldChanged", field: "isReadOnly", value: true });
    }
  }, [viewMode]);

  const handleOpenEditModal = () => {
    dispatch({ type: "fieldChanged", field: "showEditModal", value: true });
  };

  const handleCloseEditModal = () => {
    dispatch({ type: "fieldChanged", field: "showEditModal", value: false });
  };

  const handleUnlockForEdit = () => {
    if (!state.editModalReason) {
      return toast.error(
        "Please select a reason to proceed.",
        toastOptions
      );
    }
    dispatch({ type: "fieldChanged", field: "isReadOnly", value: false });
    dispatch({ type: "fieldChanged", field: "showEditModal", value: false });
  };

  const { tripId, id } = useParams();

  const { getAccessTokenSilently, user, loginWithRedirect } = useAuth0();

  const userRoles = user && user["https://new.evojets.com/roles"];

  const superAdmin =
    user &&
    userRoles.some(function (role) {
      return "Super Admin" === role || "Account Director" === role;
    });

  const salesAssistant =
    user &&
    userRoles.some(function (role) {
      return "Sales Assistant" === role;
    });

  const isSuperAdmin =
    user && userRoles.some((role) => "Super Admin" === role);

  const isVerificationAdmin = !!user?.["https://new.evojets.com/appMetadata"]?.isVerificationAdmin;

  useRedirectIfVerified(state.tripVerified, isSuperAdmin, tripId, state.tripLocked, isVerificationAdmin);

  const setUnsavedChanges = useCallback(({field, value}) => {
    dispatch({
      type: "unsavedChanges",
      field,
      value
    })
  }, []);

  const getData = async () => {
    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    ai.auth(token)
      .get("/api/commissions/service-fees")
      .then(({ data }) =>
        dispatch({
          type: "fieldChanged",
          field: "serviceFeeBrackets",
          value: data.serviceFeeBrackets,
        })
      )
      .catch((error) => {
        Sentry.captureMessage(
          `Service fee brackets load failed: ${error?.response?.status ?? "network"}`,
          "error"
        );
        toast.error("Failed to load service fee brackets. Please reload the page.", toastOptions);
      });

    let tripResponse = await ai.auth(token).get(`/api/trips/${tripId}`).catch((error) => {
      console.error(error);
      Sentry.captureException(error);
    });

    if (tripResponse && tripResponse.data) {
      dispatch({
        type: "fieldChanged",
        field: "tripTag",
        value: tripResponse.data.tripTag,
      });
      dispatch({
        type: "fieldChanged",
        field: "tripVerified",
        value: !!tripResponse.data.verified,
      });
      dispatch({
        type: "fieldChanged",
        field: "tripLocked",
        value: !!tripResponse.data.lockState?.locked,
      });
      dispatch({
        type: "fieldChanged",
        field: "itineraryLegs",
        value: tripResponse.data.itineraryData?.[0]?.legs || [],
      });
    }

    if (!id) {
      dispatch({ type: "fieldChanged", field: "loading", value: false });
    }

    if (id) {
      dispatch({
        type: "fieldChanged",
        field: "isNew",
        value: false,
      });

      dispatch({ type: "dataBeganDownloading" });

      let response = await ai
        .auth(token)
        .get(`/api/trips/${tripId}/financials/${id}`)
        .catch((error) => {
          setTimeout(() => {
            toast.error("Unauthorized!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }, 50);

          return console.error(error.response);
        });

      if (response && response.data) {
        dispatch({
          type: "dataDownloaded",
          payload: {
            data: response.data,
          },
        });
      }
    }
  };

  useEffect(() => {
    document.title = `${state.title} | evoJets HQ`;

    const lead = location?.state?.lead;
    if (lead) {
      dispatch({ type: "fieldChanged", field: "lead", value: lead });
    }

    getData();
  }, []);

  useEffect(() => {
    if (document) {
      document.getElementById("page-wrap").scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [state.loading]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!state.selectedOperator?._id || !state.selectedAircraft?.value || !state.aircraftSeats || !state.taxableOperatorPrice || !state.operatorPrice || !state.selectedFET?.value || !state.selectedSegmentFees?.value) {
      return toast.error(
        "Please fill in all required fields and retry.",
        toastOptions,
      );
    }

    if (state.isFormLoading) {
      return;
    }

    if (!state.serviceFeeBrackets && !state.isServiceFeeFrozen) {
      return toast.error(
        "Service fee brackets are not loaded. Please reload the page and retry.",
        toastOptions,
      );
    }

    const isAddAnotherClick = e?.target?.name === "addAnother";

    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    let ofrData = {
      tripId: tripId || location?.state?._id,
      operator: {
        id: state.selectedOperator?._id,
        name: state.selectedOperator?.label,
      },
      aircraft: {
        id: state.selectedAircraft?.value,
        name: state.selectedAircraft?.label,
        aircraftType: {
          id: state.selectedAircraft?.aircraftType?._id,
          name: state.selectedAircraft?.aircraftType?.name,
        },
        seats: parseInt(state.aircraftSeats),
      },
      tailNumber: state.tailNumber,
      notes: state.notes,

      yom: state?.selectedYOM?.value,
      yomIsRange: state.yomIsRange,
      interiorRefurbYear: state.selectedInteriorRefurbYear?.value,
      interiorRefurbYearIsRange: state.interiorRefurbYearIsRange,
      taxableOperatorPrice: state.taxableOperatorPrice,
      nonTaxableOperatorPrice: state.nonTaxableOperatorPrice,
      operatorPrice: state.operatorPrice,
      grossCommission: state.grossCommission,
      netCommission: state.netCommission,
      fet: {
        amount: state.FET,
        label: state?.selectedFET?.label,
        value: state?.selectedFET?.value,
      },
      segmentFees: {
        amount: state.segmentFees,
        label: state?.selectedSegmentFees?.label,
        value: state?.selectedSegmentFees?.value,
      },
      referralFees: state.referralFees,
      discount: state.discount,
      paymentType: state.paymentType,
      ccFee: state.ccFee,
      amenities: state.amenities,
      safetyStandards: state.safetyStandards,
      totalClientPayment: state.totalClientPayment,
      totalTaxesAndFees: state.totalTaxesAndFees,
      totalCostOfGoods: state.totalCostOfGoods,
      ownerApproval:
        state.ownerApproval === "no"
          ? false
          : state.ownerApproval === "yes"
          ? true
          : false,
      whichLeg: 1,
      crew: state.crew,
      editReason: editReason || state.editModalReason?.value,
    };

    if (state?.operatorCancellationPolicies?.length) {
      ofrData.operatorCancellationPolicies =
        state?.operatorCancellationPolicies.map((policy) => {
          return {
            type: policy.type,
            value: policy.value || 0,
            dueDate: policy.dueDate,
          };
        });
    }

    if (state?.dusCancellationPolicy) {
      ofrData.dusCancellationPolicy = {
        type: state?.dusCancellationPolicy?.type,
        value: state?.dusCancellationPolicy?.value,
      };
    }

    if (state.yomIsRange && state?.selectedYOMEnd?.value) {
      ofrData.yomEnd = state?.selectedYOMEnd?.value;
    }

    if (
      state.interiorRefurbYearIsRange &&
      state?.selectedInteriorRefurbYearEnd?.value
    ) {
      ofrData.interiorRefurbYearEnd =
        state?.selectedInteriorRefurbYearEnd?.value;
    }

    let response = false;

    let successVerb = "Created";

    dispatch({
      type: "loadingChanged",
      field: isAddAnotherClick ? "isSubmitAndAddAnotherLoading" : "isSubmitAndViewTripLoading",
      value: true
    });

    try {
      if (!id) {
        // only post if creating new

        response = await ai
          .auth(token)
          .post(`/api/trips/financials/create`, ofrData)
          .catch((err) => {
            console.error(err.response.data);
            toast.error(getApiErrorMessage(err, "Couldn't save the OFR."), toastOptions);

            return;
          });
      } else {
        response = await ai
          .auth(token)
          .put(`/api/trips/${tripId}/financials/${id}`, ofrData)
          .catch((err) => {
            console.error(err.response.data);
            toast.error(getApiErrorMessage(err, "Couldn't save the OFR."), toastOptions);

            return;
          });
        successVerb = "Updated";
      }
    } finally {
      dispatch({
        type: "loadingChanged",
        field: "isFormLoading",
        value: false
      });
    }

    if (!response || !response?.data) {
      return;
    }

    let data = response?.data;

    dispatch({
      type: "fieldChanged",
      field: 'unsavedChanges',
      value: {},
    });

    setTimeout(() => {
      document
        .getElementById("nav-container")
        .scrollIntoView({ behavior: "smooth" });

      toast.success(
        `Operator Financial Record ${successVerb} Successfully!`,
        toastOptions
      );
    }, 5);

    if (isAddAnotherClick) {
      //clear form and scroll to top, return

      setTimeout(() => {
        history.push({
          pathname: `/trips/${tripId}/financials/new`,
          state: { lead: state?.lead },
        });
      }, 50);

      dispatch({
        type: "resetState",
      });
    } else {
      setTimeout(() => {
        history.push({ pathname: `/trips/${tripId}` });
      }, 20);
    }
  };

  const resetSelection = (fieldName) => {
    setTimeout(() => {
      dispatch({
        type: "fieldChanged",
        field: fieldName,
        value: null,
      });
    }, 0);
  };

  const handleOperatorChange = (selectedOperator) => {
    setUnsavedChanges({
      field: 'selectedOperator',
      value: selectedOperator?._id !== state.initialFormValues.selectedOperator?._id,
    });

    if (selectedOperator) {
      if (selectedOperator?.restrictions?.length) {
        let confirm = window.confirm(
          `This operator has a status of: ${selectedOperator?.restrictions.join(
            ", "
          )}. Do you wish to proceed?`
        );

        if (!confirm) {
          return resetSelection("selectedOperator");
        }
      }

      dispatch({
        type: "fieldChanged",
        field: "selectedOperator",
        value: selectedOperator,
      });
    } else {
      resetSelection("selectedOperator");
    }
  };

  const handleAircraftChange = (selectedAircraft) => {
    setUnsavedChanges({
      field: 'selectedAircraft',
      value: selectedAircraft?.value !== state.initialFormValues.selectedAircraft?.value,
    });

    if (selectedAircraft) {
      setUnsavedChanges({
        field: 'aircraftSeats',
        value: selectedAircraft?.seats !== state.initialFormValues.aircraftSeats,
      });

      dispatch({
        type: "fieldChanged",
        field: "selectedAircraft",
        value: selectedAircraft,
      });

      dispatch({
        type: "fieldChanged",
        field: "aircraftSeats",
        value: selectedAircraft?.seats,
      });
    } else {
      setUnsavedChanges({
        field: 'aircraftSeats',
        value: !!state.initialFormValues.aircraftSeats,
      });

      resetSelection("selectedAircraft");
      dispatch({ type: "fieldChanged", field: "aircraftSeats", value: "" });
    }
  };

  const handleTextFieldChange = (e) => {
    setUnsavedChanges({
      field: e.target.name,
      value: (e.target.value ? parseValue(e.target.value, e.target.type) : "") !== state.initialFormValues[e.target.name],
    })

    dispatch({
      type: "fieldChanged",
      field: e.target.name,
      value: e.target.value,
      fieldType: e.target.type,
    });
  };

  const handleCheckboxChange = (e) => {
    setUnsavedChanges({
      field: e.target.name,
      value: e.target.checked !== state.initialFormValues[e.target.name],
    })

    dispatch({
      type: "fieldChanged",
      field: e.target.name,
      value: e.target.checked,
    });
  };

  const handlePriceFieldChange = (values, sourceInfo) => {
    const { formattedValue, value } = values;
    // Event is a Synthetic Event wrapper which holds target and other information. Source tells whether the reason for this function being triggered was an 'event' or due to a 'prop' change
    const { event, source } = sourceInfo;

    if (!event?.target) {
      return;
    }

    setUnsavedChanges({
      field: event.target.name,
      value: parseValue(value, 'float') !== state.initialFormValues[event.target.name],
    });

    dispatch({
      type: "fieldChanged",
      field: event.target.name,
      value,
      fieldType: "float",
    });
  };

  useEffect(() => {
    dispatch({
      type: "fieldChanged",
      field: "operatorPrice",
      value: (+state.taxableOperatorPrice || 0) + (+state.nonTaxableOperatorPrice || 0),
      fieldType: "float",
    });
  }, [state.taxableOperatorPrice, state.nonTaxableOperatorPrice]);

  const handleSelectChange = (selectedValue, action) => {
    setUnsavedChanges({
      field: action.name,
      value: selectedValue?.value !== state.initialFormValues[action.name]?.value,
    })

    dispatch({
      type: "fieldChanged",
      field: action.name,
      value: selectedValue,
    });
  };

  useEffect(() => {
    recalculateFET(state.selectedFET);
  }, [state.selectedFET, state.operatorPrice, state.taxableOperatorPrice]);

  useEffect(() => {
    recalculateSegmentFees(state.selectedSegmentFees);
  }, [state.selectedSegmentFees]);

  useEffect(() => {
    determineServiceFee();
  }, [
    state.taxableOperatorPrice,
    state.nonTaxableOperatorPrice,
    state.selectedFET,
    state.serviceFeeBrackets,
    state.isServiceFeeFrozen,
  ]);

  const calculateTotalClientPayment = (
    segmentFees,
    operatorPrice,
    FET,
    grossCommission,
    referralFees,
    paymentType,
    serviceFee,
    discount
  ) => {
    if (segmentFees === "" || segmentFees === null) {
      segmentFees = 0;
    }

    if (operatorPrice === "" || operatorPrice === null) {
      operatorPrice = 0;
    }

    if (FET === "" || FET === null) {
      FET = 0;
    }

    if (grossCommission === "" || grossCommission === null) {
      grossCommission = 0;
    }

    if (referralFees === "" || referralFees === null) {
      referralFees = 0;
    }

    let totalWithTaxesAndFees =
      segmentFees + operatorPrice + FET + grossCommission + referralFees;
    let ccFee = 0;

    if (serviceFee === "" || serviceFee === null) {
      serviceFee = 0;
    }

    if (discount === "" || discount === null) {
      discount = 0;
    }

    totalWithTaxesAndFees = totalWithTaxesAndFees - discount;

    if (paymentType === "cc") {
      ccFee = totalWithTaxesAndFees * 0.04;
    }
    totalWithTaxesAndFees += ccFee;

    //round up
    totalWithTaxesAndFees = Math.ceil(totalWithTaxesAndFees / 5) * 5;

    let totalTaxesAndFees = FET + segmentFees;

    dispatch({
      type: "fieldChanged",
      field: "totalTaxesAndFees",
      value: totalTaxesAndFees,
    });

    let totalCostOfGoods = operatorPrice + referralFees;

    dispatch({
      type: "fieldChanged",
      field: "totalCostOfGoods",
      value: totalCostOfGoods,
    });

    recalculateCommission(grossCommission, operatorPrice, serviceFee, discount);

    dispatch({
      type: "fieldChanged",
      field: "ccFee",
      value: ccFee,
    });

    dispatch({
      type: "fieldChanged",
      field: "totalClientPayment",
      value: totalWithTaxesAndFees,
    });
  };

  useEffect(() => {
    calculateTotalClientPayment(
      state.segmentFees,
      state.operatorPrice,
      state.FET,
      state.grossCommission,
      state.referralFees,
      state.paymentType,
      state.serviceFee,
      state.discount
    );
  }, [
    state.segmentFees,
    state.operatorPrice,
    state.FET,
    state.grossCommission,
    state.referralFees,
    state.paymentType,
    state.serviceFee,
    state.discount,
  ]);

  const recalculateFET = (fetSelection) => {
    switch (fetSelection?.value) {
      case "domestic": {
        dispatch({
          type: "fieldChanged",
          field: "FET",
          value: state.taxableOperatorPrice * 0.075,
        });
        dispatch({
          type: "fieldChanged",
          field: "showCustomFETField",
          value: false,
        });

        break;
      }

      case "225zone": {
        dispatch({
          type: "fieldChanged",
          field: "FET",
          value: state.taxableOperatorPrice * 0.075,
        });
        dispatch({
          type: "fieldChanged",
          field: "showCustomFETField",
          value: false,
        });

        break;
      }

      case "usInternational": {
        dispatch({ type: "fieldChanged", field: "FET", value: 0 });
        dispatch({
          type: "fieldChanged",
          field: "showCustomFETField",
          value: false,
        });
        break;
      }

      case "allInternational": {
        dispatch({ type: "fieldChanged", field: "FET", value: 0 });
        dispatch({
          type: "fieldChanged",
          field: "showCustomFETField",
          value: false,
        });
        break;
      }

      case "custom": {
        // dispatch({ type: "fieldChanged", field: "FET", value: "" });
        dispatch({
          type: "fieldChanged",
          field: "showCustomFETField",
          value: true,
        });
        break;
      }

      case "operatorCollected": {
        dispatch({ type: "fieldChanged", field: "FET", value: 0 });
        dispatch({
          type: "fieldChanged",
          field: "showCustomFETField",
          value: false,
        });
        break;
      }

      case "passThrough": {
        dispatch({ type: "fieldChanged", field: "FET", value: 0 });
        dispatch({
          type: "fieldChanged",
          field: "showCustomFETField",
          value: false,
        });
        break;
      }

      default: {
        dispatch({
          type: "fieldChanged",
          field: "FET",
          value: 0,
        });
        dispatch({
          type: "fieldChanged",
          field: "showCustomFETField",
          value: false,
        });
        break;
      }
    }
  };

  const handleSegmentFeesSelectChange = (selectedValue, action) => {
    setUnsavedChanges({
      field: action.name,
      value: selectedValue?.value !== state.initialFormValues[action.name]?.value,
    });

    dispatch({
      type: "fieldChanged",
      field: action.name,
      value: selectedValue,
    });

    recalculateSegmentFees(selectedValue);
  };

  const determineServiceFee = () => {
    if (state.isServiceFeeFrozen || !state.serviceFeeBrackets) {
      return;
    }

    const basis = (+state.taxableOperatorPrice || 0) + (+state.nonTaxableOperatorPrice || 0);
    const serviceFee =
      state?.selectedFET?.value === "passThrough"
        ? 0
        : findServiceFee(state.serviceFeeBrackets, basis);

    return dispatch({
      type: "fieldChanged",
      field: "serviceFee",
      value: serviceFee,
    });
  };

  const recalculateCommission = (
    grossCommission,
    operatorPrice,
    serviceFee,
    discount
  ) => {
    let percentage = null;
    if (grossCommission && operatorPrice) {
      percentage = (grossCommission / operatorPrice) * 100;
      percentage = percentage.toFixed(2);
    }

    if (!discount) {
      discount = 0;
    }

    let netCommission = grossCommission - discount - serviceFee;

    dispatch({
      type: "fieldChanged",
      field: "netCommission",
      value: netCommission,
    });

    dispatch({
      type: "fieldChanged",
      field: "commissionPercentage",
      value: percentage,
    });
  };

  const recalculateSegmentFees = (segmentFeesSelection) => {
    switch (segmentFeesSelection?.value) {
      case "domestic": {
        dispatch({
          type: "fieldChanged",
          field: "segmentFees",
          value: 31.5,
        });
        dispatch({
          type: "fieldChanged",
          field: "showCustomSegmentFeesField",
          value: false,
        });

        break;
      }

      case "225zone": {
        dispatch({
          type: "fieldChanged",
          field: "segmentFees",
          value: 139.5,
        });
        dispatch({
          type: "fieldChanged",
          field: "showCustomSegmentFeesField",
          value: false,
        });

        break;
      }

      case "usInternational": {
        dispatch({ type: "fieldChanged", field: "segmentFees", value: 139.5 });
        dispatch({
          type: "fieldChanged",
          field: "showCustomSegmentFeesField",
          value: false,
        });
        break;
      }

      case "allInternational": {
        dispatch({ type: "fieldChanged", field: "segmentFees", value: 0 });
        dispatch({
          type: "fieldChanged",
          field: "showCustomSegmentFeesField",
          value: false,
        });
        break;
      }

      case "custom": {
        // dispatch({
        //   type: "fieldChanged",
        //   field: "segmentFees",
        //   value: "",
        // });
        dispatch({
          type: "fieldChanged",
          field: "showCustomSegmentFeesField",
          value: true,
        });
        break;
      }

      case "operatorCollected": {
        dispatch({ type: "fieldChanged", field: "segmentFees", value: 0 });
        dispatch({
          type: "fieldChanged",
          field: "showCustomSegmentFeesField",
          value: false,
        });
        break;
      }

      case "passThrough": {
        dispatch({ type: "fieldChanged", field: "segmentFees", value: 0 });
        dispatch({
          type: "fieldChanged",
          field: "showCustomSegmentFeesField",
          value: false,
        });
        break;
      }

      default: {
        dispatch({
          type: "fieldChanged",
          field: "segmentFees",
          value: 0,
        });
        dispatch({
          type: "fieldChanged",
          field: "showCustomSegmentFeesField",
          value: false,
        });
        break;
      }
    }
  };

  const handleFETSelectChange = (selectedValue, action) => {
    setUnsavedChanges({
      field: action.name,
      value: selectedValue?.value !== state.initialFormValues[action.name]?.value,
    });

    dispatch({
      type: "fieldChanged",
      field: action.name,
      value: selectedValue,
    });

    recalculateFET(selectedValue);

    //match Seg Fee
    setUnsavedChanges({
      field: "selectedSegmentFees",
      value: selectedValue?.value !== state.initialFormValues.selectedSegmentFees?.value,
    });

    dispatch({
      type: "fieldChanged",
      field: "selectedSegmentFees",
      value: selectedValue,
    });
  };

  useEffect(() => {
    if (state.operatorCancellationPoliciesChanged) {
      setUnsavedChanges({
        field: "operatorCancellationPolicies",
        value: !isEqual(
          {
            operatorCancellationPolicies: state.operatorCancellationPolicies,
            dusCancellationPolicy: state.dusCancellationPolicy
          },
          {
            operatorCancellationPolicies: state.initialFormValues.operatorCancellationPolicies,
            dusCancellationPolicy: state.initialFormValues.dusCancellationPolicy
          },
        )
      });

      dispatch({
        type: "fieldChanged",
        field: "operatorCancellationPoliciesChanged",
        value: false,
      })
    }
  }, [
    setUnsavedChanges,
    state.dusCancellationPolicy,
    state.initialFormValues.dusCancellationPolicy,
    state.initialFormValues.operatorCancellationPolicies,
    state.operatorCancellationPolicies,
    state.operatorCancellationPoliciesChanged
  ]);

  return (
    <Fragment>
      {(state.isRedirecting || state.loading) && (
        <Fragment>
          <Loader additionalClasses="mt-100"></Loader>
        </Fragment>
      )}

      {!state.isRedirecting && !state.loading && (
        <Fragment>
          <PageHeader
            pageTitle={state.title}
            breadcrumbs={[
              {link: '/trips', label: 'Trips'},
              {link: `/trips/${tripId}`, label: `Trip #${state.tripTag}`},
              {label: state.isNew ? state.title : `Edit OFR #${state.ofrTag}`, isCurrentPage: true},
            ]}
            goBackLink={`/trips/${tripId}`}
            extraActions={
              state.isReadOnly ? (
                <button
                  type="button"
                  className="base-button evo-blue icon-button"
                  onClick={handleOpenEditModal}
                >
                  <span className="material-icons">edit</span>
                </button>
              ) : null
            }
          />

          <div id="sourcing-container">
            <form
              className="base-form mb-20"
              id="sourcingModuleForm"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <fieldset
                disabled={state.isReadOnly}
                style={{
                  border: "none",
                  padding: 0,
                  margin: 0,
                  minWidth: 0,
                  pointerEvents: state.isReadOnly ? "none" : "auto",
                  opacity: state.isReadOnly ? 0.9 : 1,
                }}
              >
              <div className="form-group">
                <label>Itinerary Legs Applied</label>

                {(() => {
                  const appliedLegs = id
                    ? state.itineraryLegs
                        .map((leg, index) => ({ leg, number: index + 1 }))
                        .filter(
                          ({ leg }) => leg?.ofrId && String(leg.ofrId) === String(id)
                        )
                    : [];

                  if (!appliedLegs.length) {
                    return <p className="semibold-text mb-0">N/A</p>;
                  }

                  return (
                    <ul className="mb-0">
                      {appliedLegs.map(({ leg, number }) => (
                        <li key={number}>
                          {`Leg ${number}: ${formatTripDate(
                            leg.departureDate,
                            "MM/DD/YYYY"
                          )} | ${leg?.departureAirport?.code} - ${leg?.arrivalAirport?.code}`}
                        </li>
                      ))}
                    </ul>
                  );
                })()}
              </div>

              <OperatorAutocomplete
                handleChange={handleOperatorChange}
                defaultOperatorOptions={state.operatorOptions}
                parentDispatch={dispatch}
                selectedOperator={state.selectedOperator}
                required
              />

              <AircraftAutocomplete
                handleChange={handleAircraftChange}
                defaultAircraftOptions={state.aircraftOptions}
                parentDispatch={dispatch}
                selectedAircraft={state.selectedAircraft}
                required
              />

              {(state?.sourcingRecord?.leadData?.tripType === 2 ||
                state?.lead?.tripType === 2) && (
                <FormControl className="form-group base-radio-group">
                  <label id="which-leg-label">
                    Which Leg Does This Aircraft Correspond To?{" "}
                    <span className="required">*</span>
                  </label>

                  <RadioGroup
                    aria-labelledby="which-leg-label"
                    name="whichLeg"
                    value={state.whichLeg}
                    onChange={handleTextFieldChange}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Depart Leg Only"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio />}
                      label="Return Leg Only"
                    />
                    <FormControlLabel
                      value="-1"
                      control={<Radio />}
                      label="Both Legs"
                    />
                  </RadioGroup>
                </FormControl>
              )}
              <TextInput
                name="aircraftSeats"
                label="Seats"
                handleChange={handleTextFieldChange}
                value={state.aircraftSeats}
                type="number"
                className="base-input"
                required
              />

              <TextInput
                name="tailNumber"
                label="Tail #"
                handleChange={handleTextFieldChange}
                value={state.tailNumber}
                type="text"
              />

              <div className="d-flex gap-10">
                <div className="form-group flex-grow-1 m-0">
                  <label>YOM</label>

                  <Select
                    classNamePrefix="select"
                    className="base-select yom-select"
                    defaultValue={state.selectedYOM}
                    isClearable
                    value={state.selectedYOM}
                    isSearchable
                    placeholder={"Select a Year"}
                    name="selectedYOM"
                    options={generateYearRangeOptions(1975)}
                    onChange={handleSelectChange}
                  />
                </div>

                {state.yomIsRange && (
                  <div className="form-group flex-grow-1 m-0">
                    <label>YOM End</label>

                    <Select
                      classNamePrefix="select"
                      className="base-select yom-select"
                      defaultValue={state.selectedYOMEnd}
                      isClearable
                      // key={state.selectedYOM}
                      value={state.selectedYOMEnd}
                      isSearchable
                      placeholder={"Select a Year"}
                      name="selectedYOMEnd"
                      options={generateYearRangeOptions(1975)}
                      onChange={handleSelectChange}
                    />
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>Display YOM as a range?</label>
                <Checkbox
                  checked={state.yomIsRange}
                  onChange={handleCheckboxChange}
                  name="yomIsRange"
                />
              </div>

              <OperatorCancellationPolicies
                operatorCancellationPolicies={
                  state.operatorCancellationPolicies
                }
                dusCancellationPolicy={state.dusCancellationPolicy}
                parentDispatch={dispatch}
              />

              <h5 className="mt-10">PRICING</h5>

              <div className="form-group">
                <label>Taxable Flight Charges <span className="required">*</span></label>

                <NumberFormat
                  value={state.taxableOperatorPrice}
                  thousandSeparator={true}
                  prefix={"$"}
                  onValueChange={handlePriceFieldChange}
                  placeholder="Taxable Flight Charges"
                  className="semibold-text"
                  decimalScale={2}
                  name="taxableOperatorPrice"
                />
              </div>

              <div className="form-group">
                <label>Non-Taxable Flight Charges</label>

                <NumberFormat
                  value={state.nonTaxableOperatorPrice}
                  thousandSeparator={true}
                  prefix={"$"}
                  onValueChange={handlePriceFieldChange}
                  placeholder="Non-Taxable Flight Charges"
                  className="semibold-text"
                  decimalScale={2}
                  name="nonTaxableOperatorPrice"
                />
              </div>

              <div className="form-group">
                <label>Gross Commission</label>

                <NumberFormat
                  value={state.grossCommission}
                  thousandSeparator={true}
                  prefix={"$"}
                  onValueChange={handlePriceFieldChange}
                  placeholder="Gross Commission"
                  className="semibold-text"
                  decimalScale={2}
                  name="grossCommission"
                />
              </div>

              <div className="form-group">
                <label>
                  FET <span className="required">*</span>
                </label>

                <Select
                  classNamePrefix="select"
                  className="base-select yom-select"
                  isClearable
                  isSearchable
                  value={state.selectedFET}
                  placeholder={"Select an FET Option"}
                  name="selectedFET"
                  onChange={handleFETSelectChange}
                  options={[
                    {
                      label: "US Domestic",
                      value: "domestic",
                    },
                    {
                      label: "225mi. Zone",
                      value: "225zone",
                    },
                    {
                      label: "US International",
                      value: "usInternational",
                    },
                    {
                      label: "All International",
                      value: "allInternational",
                    },
                    {
                      label: "Custom",
                      value: "custom",
                    },
                    {
                      label: "Operator Collected",
                      value: "operatorCollected",
                    },
                    {
                      label: "Pass-through",
                      value: "passThrough",
                    },
                  ]}
                />
              </div>

              {state.showCustomFETField && (
                <div className="form-group">
                  <label>Custom FET</label>

                  <NumberFormat
                    value={state.FET}
                    thousandSeparator={true}
                    prefix={"$"}
                    onValueChange={handlePriceFieldChange}
                    placeholder="Custom FET"
                    className="semibold-text"
                    decimalScale={2}
                    name="FET"
                  />
                </div>
              )}

              <div className="form-group">
                <label>
                  Segment Fees <span className="required">*</span>
                </label>

                <Select
                  classNamePrefix="select"
                  className="base-select yom-select"
                  isClearable
                  isSearchable
                  value={state.selectedSegmentFees}
                  placeholder={"Select a Segment Fee Option"}
                  name="selectedSegmentFees"
                  onChange={handleSegmentFeesSelectChange}
                  options={[
                    {
                      label: "US Domestic",
                      value: "domestic",
                    },
                    {
                      label: "225mi. Zone",
                      value: "225zone",
                    },
                    {
                      label: "US International",
                      value: "usInternational",
                    },
                    {
                      label: "All International",
                      value: "allInternational",
                    },
                    {
                      label: "Custom",
                      value: "custom",
                    },
                    {
                      label: "Operator Collected",
                      value: "operatorCollected",
                    },
                    {
                      label: "Pass-through",
                      value: "passThrough",
                    },
                  ]}
                ></Select>
              </div>

              {state.showCustomSegmentFeesField && (
                <div className="form-group">
                  <label>Custom Segment Fees</label>

                  <NumberFormat
                    value={state.segmentFees}
                    thousandSeparator={true}
                    prefix={"$"}
                    onValueChange={handlePriceFieldChange}
                    placeholder="Custom Segment Fees"
                    className="semibold-text"
                    decimalScale={2}
                    name="segmentFees"
                  />
                </div>
              )}

              {!state.isNew &&
                state.referralFees != null &&
                state.referralFees !== "" && (
                  <div className="form-group">
                    <label>Referral Fees</label>

                    <NumberFormat
                      value={state.referralFees}
                      thousandSeparator={true}
                      prefix={"$"}
                      className="semibold-text"
                      decimalScale={2}
                      name="referralFees"
                      readOnly
                    />
                  </div>
                )}

              <div className="form-group">
                <label>Credits Applied</label>

                <NumberFormat
                  value={state.discount}
                  thousandSeparator={true}
                  prefix={"$"}
                  onValueChange={handlePriceFieldChange}
                  placeholder="Credits Applied"
                  className="semibold-text"
                  decimalScale={2}
                  name="discount"
                />
              </div>

              <FormControl className="form-group base-radio-group">
                <label id="payment-type-label">Payment Type</label>

                <RadioGroup
                  aria-labelledby="payment-type-label"
                  name="paymentType"
                  value={state.paymentType}
                  onChange={handleTextFieldChange}
                >
                  <FormControlLabel
                    value="wire"
                    control={<Radio/>}
                    label="Wire"
                  />
                  <FormControlLabel
                    value="cc"
                    control={<Radio/>}
                    label="Credit Card"
                  />
                </RadioGroup>
              </FormControl>

              {!isTripClosedForUser({
                verified: state.tripVerified,
                locked: state.tripLocked,
                superAdmin: isSuperAdmin,
                verificationAdmin: isVerificationAdmin,
              }) && (
              <div
                id="sourcing-submit-button-container"
                className="display-flex flex-row flex-wrap gap-20"
              >
                <LoadingButton
                  className="mt-10 base-button evo-blue fg-1 p-8"
                  type="submit"
                  name="addAnother"
                  id="addAnother"
                  onClick={handleSubmit}
                  disabled={state.isFormLoading}
                  isLoading={state.isSubmitAndAddAnotherLoading}
                >
                  Submit &amp; Add Another
                </LoadingButton>
                <LoadingButton
                  className="mt-10 base-button evo-gunmetal fg-1 p-8"
                  id="submitAndViewTrip"
                  type="submit"
                  name="viewTrip"
                  onClick={handleSubmit}
                  disabled={state.isFormLoading}
                  isLoading={state.isSubmitAndViewTripLoading}
                >
                  Submit &amp; View Trip
                </LoadingButton>
              </div>
              )}
              </fieldset>
            </form>

            <div id="breakdown">
              <div id="breakdown-child">
                <TableContainer
                  component={Paper}
                  className="mb-30"
                  sx={
                    {
                      // maxWidth: 500,
                      // marginLeft: "auto",
                      // marginRight: "auto",
                    }
                  }
                >
                  <Table aria-label="simple table" className="breakdown-table">
                    <TableHead>
                      <TableRow key={"cogs-header"}>
                        <TableCell component="th" colSpan={3} scope="row">
                          <h5>Cost of Goods</h5>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow key={"taxable-operator-price"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text"
                        >
                          Operator Price - Taxable Flight Charges
                        </TableCell>
                        <TableCell align="right">
                          {state.taxableOperatorPrice
                            ? currencyFormatter.format(state.taxableOperatorPrice)
                            : "-"}
                        </TableCell>
                      </TableRow>

                      <TableRow key={"non-taxable-operator-price"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text"
                        >
                          Operator Price - Non-Taxable Flight Charges
                        </TableCell>
                        <TableCell align="right">
                          {state.nonTaxableOperatorPrice
                            ? currencyFormatter.format(state.nonTaxableOperatorPrice)
                            : "-"}
                        </TableCell>
                      </TableRow>

                      {!state.isNew &&
                        state.referralFees != null &&
                        state.referralFees !== "" && (
                          <TableRow key={"referral-fees"}>
                            <TableCell
                              component="th"
                              scope="row"
                              className="semibold-text black-bottom-border"
                            >
                              Referral Fees
                            </TableCell>
                            <TableCell
                              align="right"
                              className="black-bottom-border"
                            >
                              {state.referralFees
                                ? currencyFormatter.format(state.referralFees)
                                : "-"}
                            </TableCell>
                          </TableRow>
                        )}

                      <TableRow key={"total"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text gunmetal-text"
                        >
                          TOTAL
                        </TableCell>
                        <TableCell
                          align="right"
                          className="semibold-text gunmetal-text"
                        >
                          {state.totalCostOfGoods
                            ? currencyFormatter.format(state.totalCostOfGoods)
                            : "-"}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  component={Paper}
                  className="mb-30"
                  sx={
                    {
                      // maxWidth: 500,
                      // marginLeft: "auto",
                      // marginRight: "auto",
                    }
                  }
                >
                  <Table aria-label="simple table" className="breakdown-table">
                    <TableHead>
                      <TableRow key={"cogs-header"}>
                        <TableCell component="th" colSpan={3} scope="row">
                          <h5>TAXES &amp; FEES</h5>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow key={"FET"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text"
                        >
                          FET{" "}
                          {state.selectedFET?.label
                            ? `(${state.selectedFET?.label})`
                            : ""}
                        </TableCell>
                        <TableCell align="right">
                          {state.FET
                            ? currencyFormatter.format(state.FET)
                            : "-"}
                        </TableCell>
                      </TableRow>

                      <TableRow key={"seg-fees"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text black-bottom-border"
                        >
                          Seg. Fees{" "}
                          {state.selectedSegmentFees
                            ? `(${state.selectedSegmentFees?.label})`
                            : ""}
                        </TableCell>
                        <TableCell
                          align="right"
                          className="black-bottom-border"
                        >
                          {state.segmentFees
                            ? currencyFormatter.format(state.segmentFees)
                            : "-"}
                        </TableCell>
                      </TableRow>

                      <TableRow key={"total-taxes-fees"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text gunmetal-text"
                        >
                          TOTAL
                        </TableCell>
                        <TableCell
                          align="right"
                          className="semibold-text gunmetal-text"
                        >
                          {state.totalTaxesAndFees
                            ? currencyFormatter.format(state.totalTaxesAndFees)
                            : "-"}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  component={Paper}
                  className="mb-30"
                  sx={
                    {
                      // maxWidth: 500,
                      // marginLeft: "auto",
                      // marginRight: "auto",
                    }
                  }
                >
                  <Table aria-label="simple table" className="breakdown-table">
                    <TableHead>
                      <TableRow key={"cogs-header"}>
                        <TableCell component="th" colSpan={3} scope="row">
                          <h5>COMMISSION DETAILS</h5>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow key={"gross-commission"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className=" semibold-text"
                        >
                          Gross Commission
                        </TableCell>
                        <TableCell align="right" className="semibold-text">
                          {state.grossCommission
                            ? currencyFormatter.format(state.grossCommission)
                            : "-"}
                        </TableCell>
                      </TableRow>

                      {!!state.discount && (
                        <TableRow key={"discount"}>
                          <TableCell
                            component="th"
                            scope="row"
                            className="semibold-text"
                          >
                            Credits Applied
                          </TableCell>
                          <TableCell align="right">
                            {state.discount
                              ? currencyFormatter.format(state.discount)
                              : "-"}
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow key={"service-fee"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text"
                        >
                          Service Fee
                        </TableCell>
                        <TableCell align="right">
                          {state.serviceFee
                            ? currencyFormatter.format(state.serviceFee)
                            : "-"}
                        </TableCell>
                      </TableRow>

                      <TableRow key={"net-commission"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text"
                        >
                          Net Commission
                        </TableCell>
                        <TableCell align="right" className="semibold-text">
                          {state.netCommission
                            ? currencyFormatter.format(state.netCommission)
                            : "-"}
                        </TableCell>
                      </TableRow>

                      <TableRow key={"commission-percentage"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text"
                        >
                          Commission %
                        </TableCell>
                        <TableCell align="right" className="">
                          {state.commissionPercentage
                            ? `${state.commissionPercentage}%`
                            : "-"}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  component={Paper}
                  className="mb-30"
                  sx={
                    {
                      // maxWidth: 500,
                      // marginLeft: "auto",
                      // marginRight: "auto",
                    }
                  }
                >
                  <Table aria-label="simple table" className="breakdown-table">
                    <TableHead>
                      <TableRow key={"payment-details-header"}>
                        <TableCell component="th" colSpan={3} scope="row">
                          <h5>Payment Details</h5>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow key={"payment-type"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className={`semibold-text ${
                            state.paymentType !== "cc" &&
                            !state.ccFee &&
                            "black-bottom-border"
                          }`}
                        >
                          Payment Type
                        </TableCell>

                        <TableCell
                          align="right"
                          className={`semibold-text ${
                            state.paymentType !== "cc" &&
                            !state.ccFee &&
                            "black-bottom-border"
                          }`}
                        >
                          {state.paymentType === "wire"
                            ? "Wire"
                            : state.paymentType === "cc"
                              ? "Credit Card"
                              : "-"}
                        </TableCell>
                      </TableRow>

                      <TableRow
                        key={"pre-cc-total"}
                        className={`${
                          state.paymentType === "cc" && state.ccFee
                            ? ""
                            : "hidden"
                        }`}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text "
                        >
                          Pre-Credit Card Fee Total
                        </TableCell>
                        <TableCell align="right" className="">
                          {currencyFormatter.format(
                            state.totalClientPayment - state.ccFee
                          )}
                        </TableCell>
                      </TableRow>

                      <TableRow
                        key={"ccFee"}
                        className={`${
                          state.paymentType === "cc" && state.ccFee
                            ? ""
                            : "hidden"
                        }`}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text black-bottom-border"
                        >
                          Credit Card Fee
                        </TableCell>
                        <TableCell
                          align="right"
                          className="black-bottom-border"
                        >
                          {currencyFormatter.format(state.ccFee)}
                        </TableCell>
                      </TableRow>

                      {/* {state.paymentType === "cc" && state.ccFee && (
                        <TableRow key={"ccFee"}>
                          <TableCell
                            component="th"
                            scope="row"
                            className="semibold-text black-bottom-border"
                          >Credit Card Fee
                          </TableCell>
                          <TableCell
                            align="right"
                            className="black-bottom-border"
                          >
                            {currencyFormatter.format(state.ccFee)}
                          </TableCell>
                        </TableRow>
                      )} */}

                      <TableRow key={"total-client-payment"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text gunmetal-text"
                        >
                          TOTAL CLIENT PAYMENT
                        </TableCell>
                        <TableCell
                          align="right"
                          className="semibold-text gunmetal-text"
                        >
                          {state.totalClientPayment
                            ? currencyFormatter.format(state.totalClientPayment)
                            : ""}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  component={Paper}
                  className="mb-30"
                  sx={
                    {
                      // maxWidth: 500,
                      // marginLeft: "auto",
                      // marginRight: "auto",
                    }
                  }
                >
                  <Table aria-label="simple table" className="breakdown-table">
                    <TableHead>
                      <TableRow key={"payment-details-header"}>
                        <TableCell component="th" colSpan={3} scope="row">
                          <h5>Contract Details</h5>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow key={"payment-type"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className={`semibold-text`}
                        >
                          Flight Charges
                        </TableCell>

                        <TableCell align="right" className={`semibold-text`}>
                          {currencyFormatter.format(
                            state.operatorPrice +
                              state.grossCommission +
                              state.referralFees
                          )}
                        </TableCell>
                      </TableRow>

                      {state.paymentType === "cc" && state.ccFee && (
                        <TableRow key={"ccFee"}>
                          <TableCell
                            component="th"
                            scope="row"
                            className="semibold-text "
                          >
                            Credit Card Fee
                          </TableCell>
                          <TableCell align="right" className="">
                            {currencyFormatter.format(state.ccFee)}
                          </TableCell>
                        </TableRow>
                      )}

                      {!!state.discount && (
                        <TableRow key={"discount"}>
                          <TableCell
                            component="th"
                            scope="row"
                            className="semibold-text"
                          >
                            Credits Applied
                          </TableCell>
                          <TableCell align="right">
                            {state.discount
                              ? currencyFormatter.format(state.discount)
                              : "-"}
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow key={"FET"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text"
                        >
                          Federal Excise Tax
                        </TableCell>
                        <TableCell align="right">
                          {state.FET
                            ? currencyFormatter.format(state.FET)
                            : "-"}
                        </TableCell>
                      </TableRow>

                      <TableRow key={"seg-fees"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text black-bottom-border"
                        >
                          Segment Fees
                        </TableCell>
                        <TableCell
                          align="right"
                          className="black-bottom-border"
                        >
                          {state.segmentFees
                            ? currencyFormatter.format(state.segmentFees)
                            : "-"}
                        </TableCell>
                      </TableRow>

                      <TableRow key={"total-client-payment"}>
                        <TableCell
                          component="th"
                          scope="row"
                          className="semibold-text gunmetal-text"
                        >
                          TOTAL CLIENT PAYMENT
                        </TableCell>
                        <TableCell
                          align="right"
                          className="semibold-text gunmetal-text"
                        >
                          {state.totalClientPayment
                            ? currencyFormatter.format(state.totalClientPayment)
                            : ""}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>

          <UnsavedChangesWarningModal isChanged={!!Object.keys(state.unsavedChanges).length}/>

          <ReactModal
            isOpen={!!state.showEditModal}
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick={false}
            onRequestClose={handleCloseEditModal}
            style={{
              overlay: {
                zIndex: 999999,
                backgroundColor: "rgb(32 53 68 / 50%)",
              },
              content: {
                width: "auto",
                border: "none",
                overflowY: "auto",
                maxHeight: "95vh",
                minWidth: "40vw",
                borderRadius: "0",
                boxShadow: "10px 10px 91px -17px rgb(0 0 0 / 25%)",
              },
            }}
            appElement={document.getElementById("app")}
          >
            <div className="modal-header base-modal">
              <h4>Updating Signed OFR</h4>
            </div>
            <div className="modal-body base-modal">
              <p className="mt-10">
                You are about to update a Signed OFR. Please select the
                appropriate reason to proceed.
              </p>

              <div className="form-group mt-10">
                <label>
                  Reason <span className="required">*</span>
                </label>
                <Select
                  className="base-select yom-select"
                  isClearable
                  isSearchable
                  placeholder="Select a Reason"
                  name="reason"
                  value={state.editModalReason}
                  onChange={(selection) =>
                    dispatch({
                      type: "fieldChanged",
                      field: "editModalReason",
                      value: selection,
                    })
                  }
                  options={TRIP_EDIT_REASON_OPTIONS}
                  menuPosition="fixed"
                />
              </div>

              <div className="w-100 mt-20 d-flex gap-20">
                <button
                  className="base-button evo-blue flex-half"
                  type="button"
                  onClick={handleUnlockForEdit}
                >
                  Continue
                </button>
                <button
                  className="base-button btn-danger flex-half"
                  type="button"
                  onClick={handleCloseEditModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </ReactModal>
        </Fragment>
      )}

      {user &&
        user["https://new.evojets.com/roles"].includes("Super Admin") &&
        user?.sub === "auth0|5fe3c41e81637b00685cb5ff" && (
          <>
            {/* <JSONPretty id="json-pretty" data={user}></JSONPretty> */}
            <JSONPretty id="json-pretty" data={state}></JSONPretty>
            <JSONPretty id="json-pretty" data={location}></JSONPretty>
          </>
        )}
    </Fragment>
  );
};

export default OFRBuilderContent;
